import { render, staticRenderFns } from "./SelectBooleanModal.vue?vue&type=template&id=3815802c&scoped=true&lang=pug&"
import script from "./SelectBooleanModal.vue?vue&type=script&lang=ts&"
export * from "./SelectBooleanModal.vue?vue&type=script&lang=ts&"
import style0 from "./SelectBooleanModal.vue?vue&type=style&index=0&id=3815802c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3815802c",
  null
  
)

export default component.exports